<div class="relative">
  <div #chartdivperformanceevolution class="w-full h-72 md:h-96"></div>
  <div
    class="absolute flex flex-row justify-between bg-white chart-label bottom-6 text-secondary text-[9px] md:text-[12px]"
    [ngStyle]="{ width: datesWidth }"
  >
    <span>{{ firsValuetDate }}</span>
    <span>{{ lastValuetDate }}</span>
    <!-- <span bp-text-values-card>{{ datesWidth }}</span> -->
  </div>
  <bp-tooltip-chart #tool class="hidden" [tooltip]="tooltip"></bp-tooltip-chart>
</div>
